export default function() {
  controller('statistics', self => {

    var chart = Highcharts.chart('js-statistics-schedule', {
      chart: {
        type: 'areaspline',
        backgroundColor: {
          linearGradient: [0, 0, 500, 500],
          stops: [
              [0, 'rgba(255, 255, 255, 0)'],
              [1, 'rgba(200, 200, 255, 0)']
          ]
        },
        style: {
          fontFamily: 'Avenir',
          fontWeight: '300'
        }
      },
      xAxis: {
        visible: false
      },
      yAxis: {
        gridLineColor: 'rgba(255, 255, 255, .2)',
        gridZIndex: 4,
        labels: {
          enabled: false
        },
        title: {
          margin: 0,
          x: -40,
          style: {
            color: 'transparent',
            cursor: 'pointer'
          }
        }
      },
      title: {
        text: 'Number Of Purchases',
        style: {
          color: '#ffffff',
          fontSize: '16px',
          fontWeight: '300',
          letterSpacing: '.3px'
        },
        align: 'left',
        x: 20,
        y: 3
      },
      tooltip: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        shadow: false,
        padding: 0,
        style: {
          color: '#ffffff'
        },
        formatter: function() {
          return '<span style="padding-top: 20px">' + this.y + '</span>'
        }
      },
      legend: {
        itemStyle: {
          color: 'rgba(255, 255, 255, .6)',
          fontSize: '14px',
          fontWeight: '300'
        },
        align: 'right',
        verticalAlign: 'top',
        y: -51
      },
      plotOptions: {
        areaspline: {
          marker: {
            enabled: false,
            symbol: 'circle',
            fillColor: '#ffffff'
          }
        },
        bar: {
          borderRadius: 5
        },
        series: {
          lineWidth: 0
        }
      },
      credits: {
        enabled: false
      },
      series: [{
        color: 'rgba(131, 140, 199, 1)',
        name: 'Elements',
        data: [250, 430, 580, 450, 695, 555, 530, 350, 760, 520, 450, 420, 470],
        fillColor: 'rgba(131, 140, 199, .9)',
        lineColor: 'rgba(131, 140, 199, .9)'
      }, {
        color: 'rgba(83, 187, 179, 1)',
        name: 'Scrap-Kits',
        data: [450, 580, 450, 760, 600, 455, 830, 320, 860, 720, 500, 320, 370],
        fillColor: 'rgba(83, 187, 179, .4)',
        lineColor: 'rgba(83, 187, 179, .4)'
      }, {
        color: 'rgba(255, 255, 255, 1)',
        name: 'Tubes',
        data: [300, 240, 600, 250, 495, 355, 730, 450, 560, 100, 400, 220, 270],
        fillColor: 'rgba(255, 255, 255, .15)',
        lineColor: 'rgba(255, 255, 255, .15)'
      }],

      responsive: {
        rules: [{
					condition: {
            maxWidth: 500
          },
					chartOptions: {
						legend: {
              verticalAlign: 'bottom',
							itemStyle: {
								fontSize: '13.9px'
							},
              y: 0
            },
            title: {
                x: 15
            }
					}
        }]
      }
    });

    $(window).on('resize', function () {
      chart.setSize();
    });

  });
}
